// removed by extract-text-webpack-plugin
module.exports = {"container":"container-1nv1V","menu":"menu-3imx1","link":"link-3Ke7E","summa":"summa-2M7tr"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/js/components/menu-account/style.scss
 ** module id = 208
 ** module chunks = 0
 **/